export enum MoveTripTypeEnum {
    None= 0,
    Irop = 1,
    Diversion = 2,
    FlightClose = 3,
    FlyAhead = 4,
    SplitJourney = 5
}
